import Swiper from 'swiper/bundle'
import 'swiper/swiper-bundle.css'

/**
 * SWIPER モジュール
 * - .js-swiper-hero 内の .swiper をフェードエフェクト付きで自動スライド
 */
export const SWIPER = {
  init() {
    const container = document.querySelector('.js-swiper-hero')
    if (!container) return

    /* eslint-disable no-unused-vars */

    // Swiperインスタンスの初期化
    const swiper = new Swiper(container.querySelector('.swiper'), {
      effect: 'fade',
      fadeEffect: {
        crossFade: true,
      },
      slidesPerView: 1,
      spaceBetween: 0,
      centeredSlides: true,
      loop: true,
      loopAdditionalSlides: 1,
      speed: 3000,
      autoplay: {
        delay: 6000,
        disableOnInteraction: false,
        waitForTransition: false,
      },
      followFinger: false,
      // pagination: {
      //   el: '.js-swiper-hero .swiper-pagination',
      //   clickable: true,
      // },
      // breakpoints: {
      //   768: {
      //     slidesPerView: 'auto',
      //     spaceBetween: 0,
      //   },
      // },
    })

    /* eslint-enable no-unused-vars */
  },
}
